// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.framed-avatar_container_w3L_3 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.framed-avatar_avatar_YDCHc {
    position: absolute;
    width: 100%;
    height: 100%;
}
.framed-avatar_framed-avatar_X8icQ {
    width: calc(100% * 9 / 11);
    height: calc(100% * 9 / 11);
}
.framed-avatar_frame_Irkm6 {
    position: absolute;
    width: 112.5%;
    height: 112.5%;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-framed-avatar/framed-avatar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB","sourcesContent":[".container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.avatar {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n}\n.framed-avatar {\n    width: calc(100% * 9 / 11);\n    height: calc(100% * 9 / 11);\n}\n.frame {\n    position: absolute;\n    width: 112.5%;\n    height: 112.5%;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `framed-avatar_container_w3L_3`;
export var avatar = `framed-avatar_avatar_YDCHc`;
var _1 = `framed-avatar_framed-avatar_X8icQ`;
export { _1 as "framed-avatar" };
export var framedAvatar = `framed-avatar_framed-avatar_X8icQ`;
export var frame = `framed-avatar_frame_Irkm6`;
export default ___CSS_LOADER_EXPORT___;
